import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import { LoginPage } from './pages/LoginPage';
import { SurveyPage } from './pages/SurveyPage';
import { AdminLayout } from './admin/AdminLayout';
import { DashboardPage } from './admin/DashboardPage';
import { ResponsesPage } from './admin/ResponsesPage';
import { ResponseDetailPage } from './admin/ResponseDetailPage';
import { InboxPage } from './admin/InboxPage';
import { MembersPage } from './admin/MembersPage';
import { UsersPage } from './admin/UsersPage';
import './styles.css';

function RequireAuth({ children }: { children: JSX.Element }): JSX.Element {
  const auth = useAuth();
  const location = useLocation();
  if (auth.status === 'loading') return <div className="loading">Loading…</div>;
  if (auth.status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}

function RequireRole({ children, roles }: { children: JSX.Element; roles: Array<'admin' | 'reviewer' | 'dock_manager' | 'viewer'> }): JSX.Element {
  const auth = useAuth();
  if (auth.status !== 'authenticated') return <></>;
  if (!roles.includes(auth.user.role)) return <Navigate to="/admin/dashboard" replace />;
  return children;
}

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/s/:token" element={<SurveyPage />} />
          <Route path="/login" element={<LoginPage />} />

          <Route path="/admin/*" element={<RequireAuth><AdminLayout /></RequireAuth>}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="responses" element={<ResponsesPage />} />
            <Route path="responses/:id" element={<ResponseDetailPage />} />
            <Route path="inbox" element={<RequireRole roles={['admin','reviewer']}><InboxPage /></RequireRole>} />
            <Route path="members" element={<MembersPage />} />
            <Route path="users" element={<RequireRole roles={['admin']}><UsersPage /></RequireRole>} />
          </Route>

          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
